<template>
    <div class="bg-dark py-2 px-4 text-center lang-switcher">
        <template v-if="$auth.user().preferred_lang"><i class="fas fa-exclamation-triangle"></i>
            {{
                the_locale_phrase
            }}
            <router-link :to="the_link" class="btn btn-success btn-xs">{{ the_locale }}</router-link>
        </template>
        <template v-else>
            <div class="form-inline justify-content-center">
                {{ the_locale_second }}
<!--                {{$t('select_default_lang')}}-->
                <select class="form-control form-control-sm  mx-3" v-model="preferred_lang" id="pref_lang">
                    <option value="fr" key="fr">Français</option>
                    <option value="de" key="de">Deutsch</option>
                    <option value="en" key="en">English</option>
                </select>
                <button class="btn btn-success btn-xs" @click="setDefaultLanguage">{{ $t('validate') }}</button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "LocaleSwitcher",
    data(){
        return {
            preferred_lang:this.$i18n.locale
        }
    },
    methods:{
        setDefaultLanguage(){
            axios.put('user/' + this.$auth.user().id, {preferred_lang:this.preferred_lang}).then(res => {
                this.$auth.fetch()
            })
        }
    },
    computed:{
        the_link(){
          return this.$localizePath(this.$route.fullPath, this.$auth.user().preferred_lang)
        },
        the_locale(){
            if (this.$auth.user().preferred_lang==='fr'){
                return "Voir la page en Français"
            }else if(this.$auth.user().preferred_lang==='en'){
                return "See the app in English"
            }else{
                return "Siehe die Seite auf Deutsch"
            }
        },
        the_locale_phrase(){
            if (this.$auth.user().preferred_lang==='fr'){
                return "Vous visitez actuellement Classic Parts Finder dans la mauvaise langue. Cela peut provoquer des erreurs lors de la création d'annonce ou de recherche."
            }else if(this.$auth.user().preferred_lang==='en'){
                return "You are currently visiting Classic Parts Finder in the wrong language. This can cause errors when creating an ad or a research."
            }else{
                return "Sie besuchen derzeit Classic Parts Finder in der falschen Sprache. Dies kann zu Fehlern beim Erstellen von Anzeigen oder bei der Suche führen."
            }
        },
        the_locale_second(){
            if (this.$i18n.locale==='fr'){
                return "Vous visitez le site en Français, est-ce bien votre langue préférée?"
            }else if(this.$i18n.locale==='en'){
                return "You are consulting the site in English, is that your preferred language?"
            }else{
                return "Sie besuchen die Website auf Deutsch, ist das Ihre bevorzugte Sprache?"
            }
        },
    }
}
</script>

<style scoped>

</style>
